import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";

export const useConsignmentDetailsStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      '& .MuiDialog-paper': {
        width: '90vw',
        maxWidth: '900px',
        height: 'auto',
        maxHeight: '90vh',
        margin: 0,
        borderRadius: 16,
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        [theme.breakpoints.down('md')]: {
          width: '95vw',
          maxWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
          width: '100vw',
          height: '100vh',
          borderRadius: 0,
        },
      },
    },
    dialogContent: {
      padding: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      backgroundColor: '#ffffff',
      color: '#1f2937',
      padding: theme.spacing(0, 3, 2, 3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid #e5e7eb',
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    consignmentId: {
      fontSize: 24,
      fontWeight: 700,
      margin: 0,
    },
    statusChip: {
      padding: theme.spacing(0.5, 1.5),
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 600,
      textTransform: 'uppercase',
      backgroundColor: 'rgba(255,255,255,0.2)',
      color: 'white',
    },
    onTimeIndicator: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      fontSize: 14,
      fontWeight: 500,
    },
    closeButton: {
      color: '#6b7280',
      '&:hover': {
        backgroundColor: '#f3f4f6',
        color: '#1f2937',
      },
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#ffffff',
    },
    mainContent: {
      padding: '20px 24px',
      maxWidth: '100%',
      margin: '0',
      display: 'grid',
      gridTemplateColumns: '300px 1fr',
      gap: '32px',
      alignItems: 'start',
    },
    leftSidebar: {
      display: 'flex',
      flexDirection: 'column',
      paddingRight: '0px',
      '& > div:last-child': {
        marginTop: '16px',
      },
    },
    rightContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    sidebarSection: {
      marginBottom: '24px',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    sidebarLabel: {
      fontSize: 14,
      color: '#6b7280',
      fontWeight: 400,
      marginBottom: 8,
    },
    sidebarValue: {
      fontSize: 16,
      color: '#1f2937',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    sidebarMainSection: {
      marginBottom: '40px',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    sidebarSectionTitle: {
      fontSize: 18,
      fontWeight: 600,
      color: '#1f2937',
      marginBottom: 20,
      letterSpacing: '-0.025em',
    },
    sidebarSubSection: {
      marginBottom: '16px',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    orderValueLabel: {
      fontSize: 14,
      color: '#6b7280',
      fontWeight: 400,
    },
    orderValueAmount: {
      fontSize: 24,
      fontWeight: 700,
      color: '#059669',
      lineHeight: 1.1,
    },
    orderPaymentType: {
      fontSize: 20,
      fontWeight: 600,
      color: '#1f2937',
      lineHeight: 1.1,
    },
    // Origin-Destination Layout
    originDestinationCard: {
      backgroundColor: 'white',
      borderRadius: 12,
      padding: '18px',
      border: '1px solid #e5e7eb',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      marginBottom: '0px',
    },
    originHeader: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '16px',
    },
    destinationHeader: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '16px',
    },
    originTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#059669',
      letterSpacing: '-0.025em',
      paddingBottom: 4
    },
    destinationTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#dc2626',
      letterSpacing: '-0.025em',
      paddingBottom: 4
    },
    locationDetails: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    locationName: {
      fontSize: 18,
      fontWeight: 600,
      color: '#1f2937',
      display: 'flex',
      alignItems: 'center',
    },
    locationCode: {
      fontSize: 14,
      fontWeight: 500,
      color: '#6b7280',
    },
    locationAddress: {
      fontSize: 14,
      color: '#6b7280',
      lineHeight: 1.4,
    },
    locationContact: {
      fontSize: 14,
      color: '#059669',
      fontWeight: 500,
    },
    journeyArrow: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '0 0 8px 0',
      position: 'relative',
    },
    arrowLine: {
      width: '2px',
      height: '24px',
      backgroundColor: '#22c55e',
      marginBottom: '0px',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '-6px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 0,
        height: 0,
        borderLeft: '4px solid transparent',
        borderRight: '4px solid transparent',
        borderTop: '6px solid #22c55e',
      },
    },
    arrowHead: {
      display: 'none',
    },
    section: {
      backgroundColor: 'white',
      borderRadius: 12,
      padding: '24px',
      border: '1px solid #e5e7eb',
    },
    sectionTitle: {
      fontSize: 18,
      fontWeight: 600,
      color: '#1f2937',
      marginBottom: 12,
      letterSpacing: '-0.025em',
    },
    sectionIcon: {
      fontSize: 20,
      color: theme.palette.primary.main,
    },
    detailRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: 16,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    detailLabel: {
      fontSize: 14,
      color: '#6b7280',
      fontWeight: 400,
      minWidth: '120px',
    },
    detailValue: {
      fontSize: 14,
      color: '#1f2937',
      fontWeight: 500,
      flex: 1,
      textAlign: 'right',
    },
    customerName: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      marginTop: theme.spacing(2),
    },
    contactInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    contactIcon: {
      fontSize: 16,
      color: theme.palette.primary.main,
    },
    verifiedIcon: {
      fontSize: 16,
      color: '#22c55e',
      marginLeft: 8,
    },
    customerSection: {
      marginBottom: 24,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    customerLabel: {
      fontSize: 14,
      color: '#6b7280',
      fontWeight: 400,
      marginBottom: 8,
    },
    customerNameRow: {
      display: 'flex',
      alignItems: 'center',
    },
    customerNameText: {
      fontSize: 16,
      color: '#1f2937',
      fontWeight: 500,
    },
    customerValue: {
      fontSize: 16,
      color: '#1f2937',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    statusSection: {
      backgroundColor: 'white',
      borderRadius: 12,
      padding: '20px 16px',
      border: '1px solid #e5e7eb',
      marginBottom: 16,
      textAlign: 'center',
    },
    statusLabel: {
      fontSize: 16,
      color: '#6b7280',
      fontWeight: 400,
      marginBottom: 4,
    },
    statusTitle: {
      fontSize: 48,
      fontWeight: 700,
      color: '#1f2937',
      marginBottom: 8,
      letterSpacing: '-0.02em',
    },
    statusDate: {
      fontSize: 16,
      color: '#1f2937',
      fontWeight: 500,
      marginBottom: 1,
    },
    statusLastUpdated: {
      fontSize: 13,
      color: '#9ca3af',
      fontWeight: 400,
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1),
      backgroundColor: '#f5f5f5',
      borderRadius: 8,
      fontSize: 14,
    },
    timelineStatus: {
      fontSize: 18,
      fontWeight: 600,
      color: '#1f2937',
      lineHeight: 1.4,
      marginBottom: 6,
      textTransform: 'uppercase',
    },
    timelineLocation: {
      fontSize: 14,
      color: '#6b7280',
      fontWeight: 400,
      lineHeight: 1.4,
    },
    timeline: {
      backgroundColor: 'transparent',
      padding: 0,
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        left: '150px',
        top: 9,
        height: 'calc(100% - 50px)',
        width: 2,
        backgroundColor: '#22c55e',
        zIndex: 0,
      },
    },
    timelineItem: {
      display: 'grid',
      gridTemplateColumns: '140px 20px 1fr',
      alignItems: 'flex-start',
      gap: 0,
      position: 'relative',
      minHeight: 50,
      '&:last-child': {
        paddingBottom: 0,
      },
    },
    timelineDate: {
      textAlign: 'left',
      paddingTop: 0,
    },
    timelineDateText: {
      fontSize: 16,
      fontWeight: 600,
      color: '#1f2937',
    },
    timelineTimeText: {
      fontSize: 14,
      fontWeight: 400,
      color: '#6b7280',
    },
    timelineIconContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingTop: 4,
      position: 'relative',
    },
    timelineIcon: {
      width: 10,
      height: 10,
      borderRadius: '50%',
      flexShrink: 0,
      position: 'relative',
      zIndex: 2,
    },
    timelineIconCompleted: {
      backgroundColor: '#22c55e',
    },
    timelineIconCurrent: {
      backgroundColor: '#22c55e',
    },
    timelineIconPending: {
      backgroundColor: '#d1d5db',
    },
    timelineLine: {
      display: 'none', // Not used anymore - using timeline::before instead
    },
    timelineLineCompleted: {
      display: 'none', // Not used anymore - using timeline::before instead
    },
    timelineContent: {
      paddingTop: 0,
      paddingLeft: 8,
      lineHeight: 1.2,
    },
    timelineContentCurrent: {
      // No special styling needed
    },
    timelineDescription: {
      fontSize: 14,
      color: COLORS.GREY_SCALE,
      marginTop: theme.spacing(0.5),
    },
    timelineHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 0,
    },
    statusChips: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    currentChip: {
      backgroundColor: '#dcfce7',
      color: '#16a34a',
      fontSize: 12,
      fontWeight: 500,
      height: 22,
      borderRadius: 11,
      textTransform: 'capitalize',
      letterSpacing: '0.1px',
      marginTop: 4,
    },
    orderSummaryBox: {
      backgroundColor: '#f9fafb',
      padding: 20,
      borderRadius: 12,
      marginBottom: 20,
      border: '1px solid #e5e7eb',
    },
    headerRight: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    routeChip: {
      backgroundColor: '#e0f2fe',
      color: '#0277bd',
      fontSize: 12,
      fontWeight: 500
    },
    storeCodeChip: {
      backgroundColor: '#f3e8ff',
      color: '#7c3aed',
      fontSize: 14,
      fontWeight: 500,
      height: 30,
      borderRadius: 10,
      margin: '4px 0',
      display: 'inline-flex !important',
      width: 'auto !important',
      minWidth: 'auto !important',
      maxWidth: 'fit-content !important',
      alignSelf: 'flex-start',
      '& .MuiChip-label': {
        paddingLeft: 12,
        paddingRight: 12,
      },
    },
    liveTrackingButton: {
      backgroundColor: '#22c55e',
      color: 'white',
      textTransform: 'none',
      borderRadius: 16,
      padding: '6px 12px',
      fontSize: 13,
      fontWeight: 500,
      height: 32,
      minWidth: 'auto',
      minHeight: 32,
      '&:hover': {
        backgroundColor: '#16a34a',
      },
      '& .MuiButton-startIcon': {
        marginRight: 4,
        marginLeft: 0,
        '& svg': {
          fontSize: 16,
        },
      },
    },
    statusChipsContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: '12px 24px',
      borderBottom: '1px solid #e5e7eb',
    },
    orderInfoTitle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#1f2937',
      marginBottom: 12,
      letterSpacing: '-0.025em',
    },
    retryButton: {
      marginTop: 16,
    },
    categoryChip: {
      backgroundColor: '#f5f5f5',
      color: '#666',
    },
    paymentTypeLabel: {
      fontSize: 14,
      color: '#6b7280',
      fontWeight: 400,
      marginTop: 4,
    },
    orderTotalRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 12,
      paddingBottom: 12,
      borderBottom: '1px solid #e5e7eb',
    },
    orderTotalLabel: {
      fontWeight: 600,
      fontSize: 16,
      color: '#111827',
    },
    orderTotalAmount: {
      fontWeight: 700,
      fontSize: 20,
      color: '#059669',
    },
    orderDetailRow: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    actionButtons: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    topActionButtons: {
      display: 'flex',
      gap: 12,
      marginBottom: 32,
    },
    actionButton: {
      borderRadius: 8,
      textTransform: 'none',
      fontWeight: 500,
      padding: '12px 24px',
      fontSize: 14,
      boxShadow: 'none',
      minHeight: 44,
    },
    primaryButton: {
      backgroundColor: '#22c55e',
      color: 'white',
      '&:hover': {
        backgroundColor: '#16a34a',
        boxShadow: '0 2px 8px rgba(34, 197, 94, 0.3)',
      },
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      '&:hover': {
        backgroundColor: `${theme.palette.primary.main}10`,
      },
    },
    loadingContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '200px',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    errorContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '200px',
      flexDirection: 'column',
    },
    '@keyframes pulse': {
      '0%': {
        boxShadow: '0 0 0 0 rgba(33, 150, 243, 0.7)',
      },
      '70%': {
        boxShadow: '0 0 0 10px rgba(33, 150, 243, 0)',
      },
      '100%': {
        boxShadow: '0 0 0 0 rgba(33, 150, 243, 0)',
      },
    },
    '@keyframes slideIn': {
      '0%': {
        opacity: 0,
        transform: 'translateX(-20px)',
      },
      '100%': {
        opacity: 1,
        transform: 'translateX(0)',
      },
    },
  })
);
